<template>
  <div class="range-input">
    <p class="mb-0"><slot name="label"/></p>
    <div class="slidecontainer">
      <input class="slider" type="range" :value="value" :min="min" :max="max" :step="step" @input="updateValue($event)">
      <span class="px-1">{{ fixed ? (Math.round(value * 100) / 100).toFixed(2).replace(".",",") :   value }}</span><span class="unit">{{ unit }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RangeInput",
  props: {
    'value': Number,
    'min': Number,
    'max': Number,
    'step': Number,
    'unit': String,
    'fixed': {type: Boolean, default: false }
  },
  methods: {
    updateValue($event) {
      this.$emit('input',  parseFloat($event.target.value));
    }
  }
}
</script>
<style scoped>
.slider {
  -webkit-appearance: none;
  width: 70%;
  height: 8px;
  border-radius: 5px;
  background: #d4d2d2;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: #535251;
  opacity: 1;
  -webkit-transition: .2s;
  transition: opacity .2s;
  overflow: visible!important;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: none;
  background: #F5A808;
  cursor: pointer;
}
.slider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: none;
  background: #F5A808;
  cursor: pointer;
}
</style>
